export const HOLIDAY_FONT = {
  HEADING: "heading",
  SUBTITLE: "subtitle",
  EYEBROW: "eyebrow",
  NONE: "none",
};
